<template>
    <div class="group-collapse" :style="{ '--item-size': items.length }">
        <div
            class="group-collapse-item"
            v-for="(item, index) of items"
            :class="{ selected: selected === item.key }"
            :style="{ 'z-index': items.length - index }"
            @click="select(item)"
        >
            <div class="group-collapse-item-icon" v-if="item.iconType === 'component'">
                <component :class="{ [item.key]: true }" :is="item.icon" />
            </div>
            <div class="group-collapse-item-icon material-icons" v-else>
                {{ item.icon }}
            </div>

            <div class="group-collapse-item-text">{{ item.text }}</div>
        </div>
    </div>
</template>
<script>
import WhatsappBusinessIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import WhatsappIcon from "./svg-new-ui/WhatsappIcon.vue";
import MailIcon from "./svg/icons/MailIcon.vue";

export default {
    name: "GroupCollapse",
    components: { WhatsappBusinessIcon, WhatsappIcon, MailIcon },
    props: {
        value: {
            type: String,
            default: "web",
        },
        items: {
            type: Array,
            default: () => [
                {
                    key: "web",
                    icon: "public",
                    text: "Web",
                },
                {
                    key: "whatsapp",
                    icon: "WhatsappIcon",
                    iconType: "component",
                    text: "Whatsapp",
                },
                {
                    key: "mail",
                    icon: "MailIcon",
                    iconType: "component",
                    text: "Mail",
                },
            ],
        },
    },
    data: () => ({
        selected: null,
    }),
    methods: {
        select(item) {
            this.selected = item.key;
            this.$emit("selected", item.key);
        },
    },
    mounted() {
        this.selected = this.value || "web";
    },
};
</script>
<style lang="scss">
.group-collapse {
    border-radius: 30px;
    display: flex;
    align-items: center;
    width: 100%;
    overflow: hidden;

    .group-collapse-item {
        background: #f2f4f7;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-radius: 30px;
        color: black;
        transition: 0.3s all;
        padding-right: 10px;
        cursor: pointer;
        overflow: hidden;
        border: 1px solid #c7d0d7;
        height: 32px;
        gap: 3px;
        width: 60px;

        &:first-child {
            justify-content: center;
            padding: 0;
        }

        &:not(:first-child) {
            margin-left: -25px;
        }
        .group-collapse-item-text {
            line-height: 0;
            display: none;
        }

        &:hover {
            width: 140px;

            &:not(:first-child) {
                justify-content: flex-start;
                padding-left: 30px;
            }

            .group-collapse-item-text {
                display: block;
            }
        }

        .group-collapse-item-icon {
            width: 20px;
            height: 20px;

            &.material-icons {
                font-size: 20px;
                color: #5d5de3;
            }

            svg {
                width: 20px;
                height: 20px;

                &.whatsapp-v1,
                &.whatsapp-v2 {
                    path {
                        fill: #58ca63;
                    }
                }

                &.whatsapp-business {
                    path {
                        stroke: #58ca63;
                    }
                }
            }
        }

        &.selected {
            background: #c4b4f1;
            color: #5023d1;

            .group-collapse-item-icon {
                &.material-icons {
                    font-size: 20px;
                    color: #5023d1;
                }

                svg {
                    &.whatsapp-v1,
                    &.whatsapp-v2 {
                        path {
                            fill: #5023d1;
                        }
                    }

                    &.whatsapp-business {
                        path {
                            stroke: #5023d1;
                        }
                    }
                }
            }
        }
    }
}
</style>
